// src/pages/LiveAddress.js — หน้ากรอกที่อยู่จัดส่ง COD (public, cf_engine_v1)
// ลูกค้าเปิดจากลิงก์ในแชท: /live/addr/:id → กรอกที่อยู่ → พร้อมจัดส่ง
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const money = (n) => Number(n || 0).toLocaleString('en-US');
const wrap = { maxWidth: 440, margin: '0 auto', padding: 16, fontFamily: 'system-ui, sans-serif', color: '#0f172a' };
const card = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 16, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,.06)' };
const input = { width: '100%', padding: 12, border: '1px solid #cbd5e1', borderRadius: 10, fontSize: 15, marginTop: 6, boxSizing: 'border-box', fontFamily: 'inherit' };

export default function LiveAddress() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [form, setForm] = useState({ name: '', phone: '', address: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    fetch('/api/public/live/addr/' + encodeURIComponent(id))
      .then((r) => r.json())
      .then((d) => {
        if (d.error) setErr(d.error);
        else { setData(d); if (d.recipient) { setForm(d.recipient); if (d.order.status !== 'address_pending') setDone(true); } }
      })
      .catch(() => setErr('โหลดข้อมูลไม่สำเร็จ'));
  }, [id]);

  const submit = () => {
    if (!form.name || !form.phone || !form.address) { setErr('กรอกชื่อ เบอร์ และที่อยู่ให้ครบ'); return; }
    setErr(''); setBusy(true);
    fetch('/api/public/live/addr/' + encodeURIComponent(id), {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
    })
      .then((r) => r.json())
      .then((d) => { if (d.error) setErr(d.error); else setDone(true); })
      .catch(() => setErr('บันทึกไม่สำเร็จ'))
      .finally(() => setBusy(false));
  };

  if (err && !data) return <div style={wrap}><div style={card}>❌ {err}</div></div>;
  if (!data) return <div style={wrap}><div style={card}>กำลังโหลด…</div></div>;

  return (
    <div style={wrap}>
      <div style={{ textAlign: 'center', margin: '12px 0 16px', fontWeight: 700, fontSize: 18 }}>{data.shop || 'ร้านค้า'}</div>
      <div style={card}>
        <div style={{ fontSize: 13, color: '#64748b' }}>ออเดอร์ #{String(id).slice(0, 8).toUpperCase()} · เก็บเงินปลายทาง</div>
        <div style={{ margin: '12px 0', borderTop: '1px dashed #e2e8f0', paddingTop: 12 }}>
          {data.items.map((it) => (
            <div key={it.code} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 6 }}>
              <span>{it.code} {it.name} ×{it.qty}</span><span>{money(it.unit_price * it.qty)}</span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 18, borderTop: '1px solid #e2e8f0', paddingTop: 12 }}>
          <span>เก็บปลายทาง</span><span>{money(data.order.total)} บาท</span>
        </div>
      </div>

      {done ? (
        <div style={{ ...card, marginTop: 16, textAlign: 'center', borderColor: '#16a34a', background: '#f0fdf4' }}>
          <div style={{ fontSize: 40 }}>📦</div>
          <div style={{ fontWeight: 700, fontSize: 18, color: '#15803d' }}>บันทึกที่อยู่เรียบร้อย</div>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>ร้านจะจัดส่งและเก็บเงินปลายทางค่ะ</div>
        </div>
      ) : (
        <div style={{ ...card, marginTop: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>📦 ที่อยู่จัดส่ง</div>
          <label style={{ fontSize: 13, color: '#64748b' }}>ชื่อผู้รับ
            <input style={input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="ชื่อ-นามสกุล" /></label>
          <label style={{ fontSize: 13, color: '#64748b', display: 'block', marginTop: 12 }}>เบอร์โทร
            <input style={input} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="08x-xxx-xxxx" inputMode="tel" /></label>
          <label style={{ fontSize: 13, color: '#64748b', display: 'block', marginTop: 12 }}>ที่อยู่
            <textarea style={{ ...input, minHeight: 80, resize: 'vertical' }} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} placeholder="บ้านเลขที่ ถนน ตำบล อำเภอ จังหวัด รหัสไปรษณีย์" /></label>
          {err && <div style={{ color: '#b91c1c', fontSize: 13, marginTop: 8 }}>{err}</div>}
          <button onClick={submit} disabled={busy} style={{ width: '100%', marginTop: 16, padding: 14, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 700, fontSize: 15, cursor: 'pointer', opacity: busy ? 0.6 : 1 }}>
            {busy ? 'กำลังบันทึก…' : 'ยืนยันที่อยู่'}
          </button>
        </div>
      )}
    </div>
  );
}
